import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { AutomationRulesCardLayout } from '../styled/automation-rules.style';
import { ActionsExternalOptions, DeleteOptionParams } from '../types/automation-rules.type';
import { ActionCard } from '../ui-components/action-card.component';

interface ActionOptionItemProps {
    content: React.ReactElement;
    id: number;
    index: number;
    optionsLength: number;
    externalOptions: ActionsExternalOptions;
    onDeleteOptionHandler: (data: DeleteOptionParams) => () => void;
}

export const ActionOptionItem = React.memo((props: ActionOptionItemProps) => {
    const { content, id, index, optionsLength, externalOptions, onDeleteOptionHandler } = props;
    const { t } = useTranslation();

    const clonedContent = React.useMemo(
        () => React.cloneElement(content, { externalOptions }),
        [content, externalOptions]
    );

    const isDeleteShown = optionsLength > 1;

    return (
        <AutomationRulesCardLayout key={id} className="col-dir" padding="0">
            {index > 0 && (
                <PocTypography variant="subtitle2">
                    {t('settings.system.automation-rules.logical-operators.and')}
                </PocTypography>
            )}
            <ActionCard
                content={clonedContent}
                id={id}
                isDeleteShown={isDeleteShown}
                onDeleteOptionHandler={onDeleteOptionHandler}
            />
        </AutomationRulesCardLayout>
    );
});
